<template>
  <v-app>
    <v-main>
      <v-app-bar dense elevation="1">
        <v-toolbar-title></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          @click="sync"
          small
          :loading="syncing"
          :disabed="syncing"
          v-if="loggedIn"
        >
          sync</v-btn
        >
        <v-btn @click="$store.dispatch('logout')" small v-if="loggedIn">
          logout</v-btn
        >
      </v-app-bar>
      <router-view />
    </v-main>

    <!-- Bottom Navigation -->
    <v-bottom-navigation
      v-if="loggedIn"
      v-model="bottomNav"
      color="primary"
      grow
      app
    >
      <v-btn @click="$router.push('/')">
        <span>Home</span>
        <v-icon>mdi-home</v-icon>
      </v-btn>

      <v-btn @click="$router.push('/transactions')">
        <span>Transactions</span>
        <v-icon>mdi-receipt</v-icon>
      </v-btn>
    </v-bottom-navigation>

    <CheckForLatestVersion />
    <Snackbar ref="snackbar" />
  </v-app>
</template>

<script>
import CheckForLatestVersion from '@/components/CheckForLatestVersion.vue';
import Snackbar from '@/components/SnackBar.vue';
export default {
  components: {
    CheckForLatestVersion,
    Snackbar,
  },
  name: 'App',
  data: () => ({
    syncing: false,
    bottomNav: 0,
  }),
  computed: {
    loggedIn() {
      if (this.$store.state.user) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    $route(to) {
      // Update bottom navigation based on current route
      if (to.name === 'Home') {
        this.bottomNav = 0;
      } else if (to.name === 'Transactions') {
        this.bottomNav = 1;
      }
    },
  },
  mounted() {
    // Set initial bottom navigation state
    if (this.$route.name === 'Home') {
      this.bottomNav = 0;
    } else if (this.$route.name === 'Transactions') {
      this.bottomNav = 1;
    }
  },
  methods: {
    async sync() {
      this.syncing = true;
      try {
        await this.$store.dispatch('sync');
        this.syncing = false;
        this.$refs.snackbar.showSnackbar('Sync completed');
      } catch (error) {
        this.syncing = false;
        this.$refs.snackbar.showSnackbar('Sync error', 'error');
      }
    },
  },
};
</script>
